import React from "react";

import { Label } from "shared/components";
import { formatAddress } from "shared/utils";
import { IAddress } from "shared/types";
import { IconWithText, MutedText } from "shared/styles";

interface AddressInfoProps {
  address?: IAddress;
  showFlag?: boolean;
  format?: "country_first" | "country_last";
}

export const AddressInfo: React.FC<AddressInfoProps> = ({
  address,
  showFlag = true,
  format = "country_first",
}) => {
  const { country, address: formattedAddress }: any = address
    ? formatAddress(address)
    : {};

  return (
    <IconWithText>
      {showFlag && country?.flag}
      {format === "country_first" && country?.name && (
        <Label>{country?.name}</Label>
      )}
      <MutedText>
        {formattedAddress}
        {format === "country_last" && country?.name && (
          <>
            {", "} {country?.name}
          </>
        )}
      </MutedText>
    </IconWithText>
  );
};
